module.exports = "<li class=\"blog-listing__filter-option<%= isActive ? ' blog-listing__filter-option--active' : '' %>\"> <a href=# data-name=\"<%= name %>\"><%= category %></a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./src/tc/js/templates/blogs/blog-listing-filter.html
// module id = 674
// module chunks = 1